import { render, staticRenderFns } from "./addTerms.modal.vue?vue&type=template&id=1ad99002"
import script from "./addTerms.modal.vue?vue&type=script&lang=js"
export * from "./addTerms.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports